
import PageInstance from "app/page_instance/index"

const getPageElementForTracking = () => {
  switch (PageInstance.currentPage()){
    case PageInstance.Enum.city_level_residential_for_rent_listing_search_page:
      return "city-listing-search-pages-for-rent"
    case PageInstance.Enum.city_level_residential_for_sale_listing_search_page:
      return "city-listing-search-pages-for-sale"
    case PageInstance.Enum.single_listing_details_page:
      return "full-listing-details-pages"
    default:
      return "all-pages"
  }
}

export default {
  getPageElementForTracking,
}
